document.querySelectorAll('.lpb-quiz').forEach(function (sectionEl) {
  var configEl = sectionEl.querySelector('.lpb-quiz__config');
  if (!configEl) return;

  var config   = JSON.parse(configEl.textContent);
  var card     = sectionEl.querySelector('[data-quiz-card]');
  var results  = sectionEl.querySelector('[data-results]');
  var questions = Array.from(sectionEl.querySelectorAll('[data-question]'));
  var total    = questions.length;

  // Cache per-question nodes upfront — no DOM queries on user interaction
  var qData = questions.map(function (q) {
    return {
      el:          q,
      correct:     parseInt(q.dataset.correct, 10),
      answers:     Array.from(q.querySelectorAll('[data-answer]')),
      explanation: q.querySelector('[data-explanation]'),
      actions:     q.querySelector('[data-actions]')
    };
  });

  // Cache result nodes
  var resEmoji   = results.querySelector('[data-result-emoji]');
  var resScore   = results.querySelector('[data-result-score]');
  var resMessage = results.querySelector('[data-result-message]');

  var current      = 0;
  var correctCount = 0;

  // Single delegated listener for the entire card
  card.addEventListener('click', function (e) {
    var answerBtn = e.target.closest('[data-answer]');
    if (answerBtn && !answerBtn.disabled) { onAnswer(answerBtn); return; }
    if (e.target.closest('[data-next]'))   { goNext();           return; }
    if (e.target.closest('[data-finish]')) { showResults();      return; }
    if (e.target.closest('[data-replay]')) { reset();            return; }
  });

  function onAnswer(btn) {
    var q       = qData[current];
    var chosen  = parseInt(btn.dataset.answer, 10);
    var correct = q.correct;

    q.answers.forEach(function (b) {
      b.disabled = true;
      var i = parseInt(b.dataset.answer, 10);
      if (i === correct)             b.classList.add('lpb-quiz__answer--correct');
      else if (i === chosen)         b.classList.add('lpb-quiz__answer--wrong');
    });

    if (chosen === correct) correctCount++;
    if (q.explanation) q.explanation.hidden = false;
    q.actions.hidden = false;
  }

  function goNext() {
    qData[current].el.hidden = true;
    current++;
    qData[current].el.hidden = false;
  }

  function showResults() {
    qData[current].el.hidden = true;
    results.hidden = false;

    var pct  = Math.round((correctCount / total) * 100);
    var tier = pct >= config.scoreThresholds.perfect ? 'perfect'
             : pct >= config.scoreThresholds.good    ? 'good'
             : 'low';

    resEmoji.textContent   = config.emojis[tier];
    resScore.textContent   = correctCount + '/' + total;
    resMessage.textContent = config.messages[tier];
  }

  function reset() {
    correctCount = 0;
    results.hidden = true;

    qData.forEach(function (q) {
      q.answers.forEach(function (b) {
        b.disabled = false;
        b.classList.remove('lpb-quiz__answer--correct', 'lpb-quiz__answer--wrong');
      });
      if (q.explanation) q.explanation.hidden = true;
      q.actions.hidden = true;
      q.el.hidden = true;
    });

    current = 0;
    qData[0].el.hidden = false;
  }
});
